import { render, staticRenderFns } from "./popupChangePassword.vue?vue&type=template&id=46566880&scoped=true"
import script from "./popupChangePassword.vue?vue&type=script&lang=js"
export * from "./popupChangePassword.vue?vue&type=script&lang=js"
import style0 from "./popupChangePassword.vue?vue&type=style&index=0&id=46566880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46566880",
  null
  
)

export default component.exports